import { instance } from 'common/axios/axios';
import { getApiUrl } from 'common/axios/getApiUrl';

/**
 * 한국관광공사 TourAPI 연동
 * https://api.visitkorea.or.kr/
 *
 * 국내: TourAPI (무료, 공공데이터포털 인증키)
 * 해외: 하드코딩 기본 데이터 + 향후 Amadeus/Sygic API 연동 가능
 */


// 국내 지역코드 (TourAPI areaCode)
export const DOMESTIC_AREA_CODES: Record<string, { code: string; name: string; emoji: string }> = {
    seoul: { code: '1', name: '서울', emoji: '' },
    incheon: { code: '2', name: '인천', emoji: '' },
    daejeon: { code: '3', name: '대전', emoji: '' },
    daegu: { code: '4', name: '대구', emoji: '' },
    gwangju: { code: '5', name: '광주', emoji: '' },
    busan: { code: '6', name: '부산', emoji: '' },
    ulsan: { code: '7', name: '울산', emoji: '' },
    sejong: { code: '8', name: '세종', emoji: '' },
    gyeonggi: { code: '31', name: '경기', emoji: '' },
    gangwon: { code: '32', name: '강원', emoji: '' },
    chungbuk: { code: '33', name: '충북', emoji: '' },
    chungnam: { code: '34', name: '충남', emoji: '' },
    gyeongbuk: { code: '35', name: '경북', emoji: '' },
    gyeongnam: { code: '36', name: '경남', emoji: '' },
    jeonbuk: { code: '37', name: '전북', emoji: '' },
    jeonnam: { code: '38', name: '전남', emoji: '' },
    jeju: { code: '39', name: '제주', emoji: '' },
};

// 한국 인기 관광 도시 — 좌표는 시청이 아닌 "가장 유명한 휴양지/관광 명소" 중심.
// 여행 모임 시 이 좌표 기준 5km 반경 nearbyPlaces 가 호출되므로 시 중심부 호텔이 아닌
// 실제 사용자가 머무는 휴양지 호텔/펜션이 추천 결과에 우선 노출되도록 한다.
export const KR_POPULAR_CITIES: Record<string, { name: string; emoji: string; lat: number; lng: number; description: string }> = {
    'kr-gyeongju':   { name: '경주',   emoji: '', lat: 35.7903, lng: 129.3315, description: '불국사, 첨성대, 동궁' },          // 보문관광단지
    'kr-jeonju':     { name: '전주',   emoji: '', lat: 35.8156, lng: 127.1494, description: '한옥마을, 비빔밥' },               // 한옥마을
    'kr-andong':     { name: '안동',   emoji: '', lat: 36.5398, lng: 128.5210, description: '하회마을, 안동찜닭' },             // 하회마을
    'kr-yeosu':      { name: '여수',   emoji: '', lat: 34.7350, lng: 127.7400, description: '여수밤바다, 오동도' },             // 돌산/이순신 광장
    'kr-tongyeong':  { name: '통영',   emoji: '', lat: 34.8420, lng: 128.4335, description: '한산도, 해상케이블카' },           // 케이블카/동피랑
    'kr-geoje':      { name: '거제',   emoji: '', lat: 34.8045, lng: 128.5510, description: '바람의 언덕, 외도' },             // 바람의 언덕
    'kr-namhae':     { name: '남해',   emoji: '', lat: 34.7474, lng: 127.9020, description: '독일마을, 다랭이마을' },           // 독일마을
    'kr-gangneung':  { name: '강릉',   emoji: '', lat: 37.7950, lng: 128.9100, description: '경포대, 정동진, 안목' },           // 경포해변
    'kr-sokcho':     { name: '속초',   emoji: '', lat: 38.2074, lng: 128.6018, description: '설악산, 외옹치' },                // 속초해변/외옹치
    'kr-yangyang':   { name: '양양',   emoji: '', lat: 38.0552, lng: 128.6680, description: '죽도해변, 서핑' },                  // 죽도해변
    'kr-pyeongchang':{ name: '평창',   emoji: '', lat: 37.6543, lng: 128.6800, description: '대관령, 알펜시아' },               // 알펜시아 리조트
    'kr-jeongseon':  { name: '정선',   emoji: '', lat: 37.3804, lng: 128.6608, description: '아우라지, 화암동굴' },             // 아우라지
    'kr-chuncheon':  { name: '춘천',   emoji: '', lat: 37.7901, lng: 127.5258, description: '남이섬, 닭갈비' },                 // 남이섬
    'kr-gapyeong':   { name: '가평',   emoji: '', lat: 37.7929, lng: 127.5167, description: '쁘띠프랑스, 자라섬' },             // 자라섬
    'kr-yangpyeong': { name: '양평',   emoji: '', lat: 37.5325, lng: 127.3084, description: '두물머리, 세미원' },                // 두물머리
    'kr-danyang':    { name: '단양',   emoji: '', lat: 36.9886, lng: 128.3658, description: '도담삼봉, 단양팔경' },             // 도담삼봉
    'kr-buyeo':      { name: '부여',   emoji: '', lat: 36.2756, lng: 126.9097, description: '백제유적, 궁남지' },               // 궁남지/유적
    'kr-gongju':     { name: '공주',   emoji: '', lat: 36.4521, lng: 127.1119, description: '공산성, 무령왕릉' },               // 공산성
    'kr-boryeong':   { name: '보령',   emoji: '', lat: 36.3247, lng: 126.5485, description: '대천해수욕장, 머드축제' },         // 대천해수욕장
    'kr-taean':      { name: '태안',   emoji: '', lat: 36.5012, lng: 126.3210, description: '안면도, 꽃지해수욕장' },          // 꽃지해변
    'kr-haenam':     { name: '해남',   emoji: '', lat: 34.3009, lng: 126.5418, description: '땅끝마을, 대흥사' },               // 땅끝마을
    'kr-suncheon':   { name: '순천',   emoji: '', lat: 34.8856, lng: 127.5135, description: '순천만습지, 낙안읍성' },           // 순천만국가정원
    'kr-damyang':    { name: '담양',   emoji: '', lat: 35.3206, lng: 126.9885, description: '죽녹원, 메타세콰이어길' },         // 죽녹원
    'kr-yeoju':      { name: '여주',   emoji: '', lat: 37.3146, lng: 127.6398, description: '여주프리미엄, 신륵사' },           // 신륵사
    'kr-pohang':     { name: '포항',   emoji: '', lat: 36.0758, lng: 129.5610, description: '호미곶, 영일대' },                  // 호미곶
    'kr-mokpo':      { name: '목포',   emoji: '', lat: 34.7800, lng: 126.3870, description: '유달산, 갓바위' },                 // 유달산/북항
    'kr-ganghwa':    { name: '강화도', emoji: '', lat: 37.6700, lng: 126.4400, description: '전등사, 마니산' },                  // 전등사/마니산
    'kr-namiseom':   { name: '남이섬', emoji: '', lat: 37.7901, lng: 127.5258, description: '메타세콰이어길' },                 // 남이섬
    'kr-uljin':      { name: '울진',   emoji: '', lat: 36.9930, lng: 129.4006, description: '대게, 성류굴' },                  // 후포항
    'kr-yeongdeok': { name: '영덕',    emoji: '', lat: 36.4156, lng: 129.3658, description: '영덕대게, 해맞이공원' },           // 강구항
};

// 일본 지역 데이터
export const JAPAN_REGIONS: Record<string, { name: string; nameEn: string; emoji: string; lat: number; lng: number; description: string }> = {
    'jp-tokyo': { name: '도쿄', nameEn: 'Tokyo', emoji: '', lat: 35.6762, lng: 139.6503, description: '시부야, 아사쿠사, 아키하바라' },
    'jp-osaka': { name: '오사카', nameEn: 'Osaka', emoji: '', lat: 34.6937, lng: 135.5023, description: '도톤보리, 오사카성, 유니버설' },
    'jp-kyoto': { name: '교토', nameEn: 'Kyoto', emoji: '', lat: 35.0116, lng: 135.7681, description: '금각사, 후시미 이나리' },
    'jp-fukuoka': { name: '후쿠오카', nameEn: 'Fukuoka', emoji: '', lat: 33.5904, lng: 130.4017, description: '캐널시티, 텐진, 하카타라멘' },
    'jp-sapporo': { name: '삿포로', nameEn: 'Sapporo', emoji: '', lat: 43.0618, lng: 141.3545, description: '눈 축제, 오타루, 맥주' },
    'jp-okinawa': { name: '오키나와', nameEn: 'Okinawa', emoji: '', lat: 26.3344, lng: 127.8056, description: '해변, 수족관, 슈리성' },
    'jp-nagoya': { name: '나고야', nameEn: 'Nagoya', emoji: '', lat: 35.1815, lng: 136.9066, description: '나고야성, 히츠마부시' },
    'jp-yokohama': { name: '요코하마', nameEn: 'Yokohama', emoji: '', lat: 35.4437, lng: 139.6380, description: '차이나타운, 미나토미라이' },
    'jp-kobe': { name: '고베', nameEn: 'Kobe', emoji: '', lat: 34.6901, lng: 135.1956, description: '고베 소고기, 항구' },
    'jp-hiroshima': { name: '히로시마', nameEn: 'Hiroshima', emoji: '', lat: 34.3853, lng: 132.4553, description: '평화기념관, 미야지마' },
    'jp-sendai': { name: '센다이', nameEn: 'Sendai', emoji: '', lat: 38.2682, lng: 140.8694, description: '규탕, 마츠시마, 다나바타' },
    'jp-kanazawa': { name: '가나자와', nameEn: 'Kanazawa', emoji: '', lat: 36.5613, lng: 136.6562, description: '겐로쿠엔, 해산물' },
    'jp-nara': { name: '나라', nameEn: 'Nara', emoji: '', lat: 34.6851, lng: 135.8048, description: '사슴공원, 도다이지' },
    'jp-hakone': { name: '하코네', nameEn: 'Hakone', emoji: '', lat: 35.2323, lng: 139.1069, description: '온천, 후지산 뷰' },
    'jp-nikko': { name: '닛코', nameEn: 'Nikko', emoji: '', lat: 36.7199, lng: 139.6982, description: '도쇼구, 단풍' },
    'jp-beppu': { name: '벳푸', nameEn: 'Beppu', emoji: '', lat: 33.2846, lng: 131.4914, description: '지옥온천, 료칸' },
};

// 일본 인기 세부 스팟 (도쿄/오사카/교토 등 주요 도시 내 인기 지구)
export const JP_POPULAR_SPOTS: Record<string, { name: string; nameEn: string; emoji: string; lat: number; lng: number; description: string }> = {
    'jp-shibuya':     { name: '시부야',     nameEn: 'Shibuya',     emoji: '', lat: 35.6580, lng: 139.7016, description: '도쿄 — 핫플, 스크램블' },
    'jp-shinjuku':    { name: '신주쿠',     nameEn: 'Shinjuku',    emoji: '', lat: 35.6938, lng: 139.7034, description: '도쿄 — 야경, 골든가이' },
    'jp-asakusa':     { name: '아사쿠사',   nameEn: 'Asakusa',     emoji: '', lat: 35.7148, lng: 139.7967, description: '도쿄 — 센소지, 전통거리' },
    'jp-akihabara':   { name: '아키하바라', nameEn: 'Akihabara',   emoji: '', lat: 35.7022, lng: 139.7745, description: '도쿄 — 전자상가, 애니' },
    'jp-ginza':       { name: '긴자',       nameEn: 'Ginza',       emoji: '', lat: 35.6717, lng: 139.7659, description: '도쿄 — 명품, 미식' },
    'jp-harajuku':    { name: '하라주쿠',   nameEn: 'Harajuku',    emoji: '', lat: 35.6702, lng: 139.7024, description: '도쿄 — 패션, 카와이' },
    'jp-odaiba':      { name: '오다이바',   nameEn: 'Odaiba',      emoji: '', lat: 35.6280, lng: 139.7763, description: '도쿄 — 레인보우브릿지' },
    'jp-tokyo-disney':{ name: '도쿄 디즈니', nameEn: 'Tokyo Disney',emoji: '', lat: 35.6329, lng: 139.8804, description: '치바 — 디즈니랜드/씨' },
    'jp-skytree':     { name: '도쿄 스카이트리', nameEn: 'Tokyo Skytree', emoji: '', lat: 35.7100, lng: 139.8107, description: '도쿄 — 야경 명소' },

    'jp-dotonbori':   { name: '도톤보리',   nameEn: 'Dotonbori',   emoji: '', lat: 34.6687, lng: 135.5022, description: '오사카 — 글리코, 먹방' },
    'jp-umeda':       { name: '우메다',     nameEn: 'Umeda',       emoji: '', lat: 34.7025, lng: 135.4959, description: '오사카 — 쇼핑, 야경' },
    'jp-shinsaibashi':{ name: '신사이바시', nameEn: 'Shinsaibashi', emoji: '', lat: 34.6736, lng: 135.5024, description: '오사카 — 쇼핑거리' },
    'jp-osaka-castle':{ name: '오사카성',   nameEn: 'Osaka Castle',emoji: '', lat: 34.6873, lng: 135.5262, description: '오사카 — 천수각' },
    'jp-usj':         { name: '유니버설 스튜디오', nameEn: 'USJ',  emoji: '', lat: 34.6657, lng: 135.4323, description: '오사카 — 테마파크' },

    'jp-arashiyama':  { name: '아라시야마', nameEn: 'Arashiyama',  emoji: '', lat: 35.0094, lng: 135.6772, description: '교토 — 대나무숲, 도게츠교' },
    'jp-gion':        { name: '기온',       nameEn: 'Gion',        emoji: '', lat: 35.0036, lng: 135.7780, description: '교토 — 게이샤, 전통거리' },
    'jp-fushimi':     { name: '후시미이나리',nameEn: 'Fushimi',    emoji: '', lat: 34.9671, lng: 135.7727, description: '교토 — 천 개의 도리이' },

    'jp-otaru':       { name: '오타루',     nameEn: 'Otaru',       emoji: '', lat: 43.1907, lng: 140.9947, description: '홋카이도 — 운하, 오르골' },
    'jp-furano':      { name: '후라노',     nameEn: 'Furano',      emoji: '', lat: 43.3500, lng: 142.3833, description: '홋카이도 — 라벤더밭' },
    'jp-biei':        { name: '비에이',     nameEn: 'Biei',        emoji: '', lat: 43.5883, lng: 142.4691, description: '홋카이도 — 청의 호수' },

    'jp-naha':        { name: '나하',       nameEn: 'Naha',        emoji: '', lat: 26.2123, lng: 127.6792, description: '오키나와 — 슈리성, 국제거리' },
    'jp-churaumi':    { name: '추라우미',   nameEn: 'Churaumi',    emoji: '', lat: 26.6944, lng: 127.8773, description: '오키나와 — 수족관' },

    'jp-kamakura':    { name: '가마쿠라',   nameEn: 'Kamakura',    emoji: '', lat: 35.3192, lng: 139.5469, description: '도쿄 근교 — 대불, 해변' },
    'jp-fuji':        { name: '후지산',     nameEn: 'Mt. Fuji',    emoji: '', lat: 35.3606, lng: 138.7274, description: '시즈오카 — 일본 상징' },
    'jp-kawaguchiko': { name: '카와구치코', nameEn: 'Kawaguchiko', emoji: '', lat: 35.5167, lng: 138.7667, description: '야마나시 — 후지산 5호' },
};

// 국가별 국내 지역 매핑
export type CountryCode = 'KR' | 'JP' | string;

export const getDomesticRegions = (countryCd: CountryCode) => {
    switch (countryCd) {
        case 'KR': {
            const provinces = Object.entries(DOMESTIC_AREA_CODES).map(([id, data]) => ({
                id, name: data.name, emoji: data.emoji, areaCode: data.code,
                description: '', lat: undefined as number | undefined, lng: undefined as number | undefined,
            }));
            const cities = Object.entries(KR_POPULAR_CITIES).map(([id, data]) => ({
                id, name: data.name, emoji: data.emoji, areaCode: undefined as string | undefined,
                description: data.description, lat: data.lat, lng: data.lng,
            }));
            return [...provinces, ...cities];
        }
        case 'JP': {
            const regions = Object.entries(JAPAN_REGIONS).map(([id, data]) => ({
                id, name: data.name, nameEn: data.nameEn, emoji: data.emoji,
                lat: data.lat, lng: data.lng, description: data.description,
            }));
            const spots = Object.entries(JP_POPULAR_SPOTS).map(([id, data]) => ({
                id, name: data.name, nameEn: data.nameEn, emoji: data.emoji,
                lat: data.lat, lng: data.lng, description: data.description,
            }));
            return [...regions, ...spots];
        }
        default:
            return []; // 기타 국가: 빈 목록 (지도 기반 탐색만)
    }
};

/**
 * 도시명/지명을 받아 해당 위치의 "휴양지/관광 명소 중심" 좌표를 반환.
 * KR_POPULAR_CITIES → JP_POPULAR_SPOTS → JAPAN_REGIONS 순서로 매칭.
 *
 * 매칭이 되면 시청 좌표 대신 휴양지 좌표 사용 → 강릉 입력 시 경포해변,
 * 부산 입력 시 해운대 같은 식으로 추천 호텔/관광지가 실제 사용자가 머무는 지역에서 검색됨.
 */
export const findKnownDestinationCenter = (name: string): { lat: number; lng: number } | null => {
    const q = (name || '').trim();
    if (!q) return null;
    const sources = [
        KR_POPULAR_CITIES,
        JP_POPULAR_SPOTS,
        JAPAN_REGIONS,
        // 해외 도시 좌표는 바로 아래 OVERSEAS_DESTINATIONS 에 있었는데 여기서 보지 않았습니다.
        // 그래서 파리·방콕·다낭 같은 여행지는 좌표를 못 찾고, 부르는 쪽이 집결지(대개 한국
        // 공항) 좌표로 되돌아가 호텔·장소 추천이 한국에서 검색됐습니다.
        // 국내·일본이 먼저 걸리도록 맨 뒤에 둡니다.
        OVERSEAS_DESTINATIONS,
    ];
    for (const src of sources) {
        for (const data of Object.values(src)) {
            const n = (data as any).name as string;
            if (!n) continue;
            if (q === n || q.includes(n) || n.includes(q)) {
                return { lat: (data as any).lat, lng: (data as any).lng };
            }
        }
    }
    return null;
};

export const getCountryName = (countryCd: CountryCode): string => {
    const names: Record<string, string> = { KR: '한국', JP: '일본', US: '미국', CN: '중국', TW: '대만', TH: '태국', VN: '베트남' };
    return names[countryCd] || countryCd;
};

// 해외 인기 여행지 (향후 API 연동 시 대체)
export const OVERSEAS_DESTINATIONS = [
    // 동아시아
    { id: 'japan-tokyo', name: '도쿄', country: '일본', countryEn: 'Japan', emoji: '🇯🇵', description: '시부야, 아사쿠사, 아키하바라', popular: true, lat: 35.6762, lng: 139.6503 },
    { id: 'japan-osaka', name: '오사카', country: '일본', countryEn: 'Japan', emoji: '🇯🇵', description: '도톤보리, 오사카성, 유니버설', popular: true, lat: 34.6937, lng: 135.5023 },
    { id: 'japan-kyoto', name: '교토', country: '일본', countryEn: 'Japan', emoji: '🇯🇵', description: '금각사, 후시미 이나리', lat: 35.0116, lng: 135.7681 },
    { id: 'japan-fukuoka', name: '후쿠오카', country: '일본', countryEn: 'Japan', emoji: '🇯🇵', description: '캐널시티, 텐진', lat: 33.5904, lng: 130.4017 },
    { id: 'japan-okinawa', name: '오키나와', country: '일본', countryEn: 'Japan', emoji: '🇯🇵', description: '해변, 미군기지, 수족관', lat: 26.3344, lng: 127.8056 },
    { id: 'taiwan-taipei', name: '타이베이', country: '대만', countryEn: 'Taiwan', emoji: '🇹🇼', description: '101타워, 지우펀, 야시장', popular: true, lat: 25.0330, lng: 121.5654 },
    { id: 'china-shanghai', name: '상하이', country: '중국', countryEn: 'China', emoji: '🇨🇳', description: '와이탄, 동방명주', lat: 31.2304, lng: 121.4737 },
    { id: 'china-beijing', name: '베이징', country: '중국', countryEn: 'China', emoji: '🇨🇳', description: '만리장성, 자금성', lat: 39.9042, lng: 116.4074 },
    { id: 'hongkong', name: '홍콩', country: '홍콩', countryEn: 'Hong Kong', emoji: '🇭🇰', description: '빅토리아 피크, 야경', popular: true, lat: 22.3193, lng: 114.1694 },
    { id: 'macau', name: '마카오', country: '마카오', countryEn: 'Macau', emoji: '🇲🇴', description: '카지노, 세나도 광장', lat: 22.1987, lng: 113.5439 },

    // 동남아시아
    { id: 'thailand-bangkok', name: '방콕', country: '태국', countryEn: 'Thailand', emoji: '🇹🇭', description: '왕궁, 카오산로드, 짜뚜짝', popular: true, lat: 13.7563, lng: 100.5018 },
    { id: 'thailand-phuket', name: '푸켓', country: '태국', countryEn: 'Thailand', emoji: '🇹🇭', description: '파통 비치, 피피섬', lat: 7.8804, lng: 98.3923 },
    { id: 'thailand-chiangmai', name: '치앙마이', country: '태국', countryEn: 'Thailand', emoji: '🇹🇭', description: '사원, 야시장, 코끼리', lat: 18.7883, lng: 98.9853 },
    { id: 'vietnam-danang', name: '다낭', country: '베트남', countryEn: 'Vietnam', emoji: '🇻🇳', description: '미케비치, 바나힐, 호이안', popular: true, lat: 16.0471, lng: 108.2068 },
    { id: 'vietnam-hanoi', name: '하노이', country: '베트남', countryEn: 'Vietnam', emoji: '🇻🇳', description: '호안끼엠, 하롱베이', lat: 21.0278, lng: 105.8342 },
    { id: 'vietnam-hochiminh', name: '호치민', country: '베트남', countryEn: 'Vietnam', emoji: '🇻🇳', description: '벤탄시장, 쿠치터널', lat: 10.8231, lng: 106.6297 },
    { id: 'singapore', name: '싱가포르', country: '싱가포르', countryEn: 'Singapore', emoji: '🇸🇬', description: '마리나베이, 센토사, 가든스', popular: true, lat: 1.3521, lng: 103.8198 },
    { id: 'philippines-cebu', name: '세부', country: '필리핀', countryEn: 'Philippines', emoji: '🇵🇭', description: '오슬롭, 카와산폭포', popular: true, lat: 10.3157, lng: 123.8854 },
    { id: 'philippines-boracay', name: '보라카이', country: '필리핀', countryEn: 'Philippines', emoji: '🇵🇭', description: '화이트비치, 액티비티', lat: 11.9674, lng: 121.9248 },
    { id: 'indonesia-bali', name: '발리', country: '인도네시아', countryEn: 'Indonesia', emoji: '🇮🇩', description: '우붓, 꾸따 비치, 사원', popular: true, lat: -8.3405, lng: 115.0920 },
    { id: 'malaysia-kl', name: '쿠알라룸푸르', country: '말레이시아', countryEn: 'Malaysia', emoji: '🇲🇾', description: '페트로나스, 바투동굴', lat: 3.1390, lng: 101.6869 },
    { id: 'cambodia-siem', name: '씨엠립', country: '캄보디아', countryEn: 'Cambodia', emoji: '🇰🇭', description: '앙코르와트', lat: 13.3671, lng: 103.8448 },
    { id: 'laos-vientiane', name: '비엔티안', country: '라오스', countryEn: 'Laos', emoji: '🇱🇦', description: '루앙프라방, 메콩강', lat: 17.9757, lng: 102.6331 },
    { id: 'myanmar-bagan', name: '바간', country: '미얀마', countryEn: 'Myanmar', emoji: '🇲🇲', description: '사원 유적지, 열기구', lat: 21.1717, lng: 94.8585 },

    // 미주/유럽/오세아니아
    { id: 'usa-hawaii', name: '하와이', country: '미국', countryEn: 'USA', emoji: '🇺🇸', description: '와이키키, 다이아몬드헤드', popular: true, lat: 21.3069, lng: -157.8583 },
    { id: 'usa-la', name: 'LA', country: '미국', countryEn: 'USA', emoji: '🇺🇸', description: '할리우드, 산타모니카', lat: 34.0522, lng: -118.2437 },
    { id: 'usa-ny', name: '뉴욕', country: '미국', countryEn: 'USA', emoji: '🇺🇸', description: '타임스퀘어, 자유의 여신상', lat: 40.7128, lng: -74.0060 },
    { id: 'usa-guam', name: '괌', country: '미국', countryEn: 'USA', emoji: '🇬🇺', description: '투몬비치, 쇼핑', popular: true, lat: 13.4443, lng: 144.7937 },
    { id: 'usa-saipan', name: '사이판', country: '미국', countryEn: 'USA', emoji: '🇲🇵', description: '마나가하섬, 그로토', lat: 15.1850, lng: 145.7474 },
    { id: 'france-paris', name: '파리', country: '프랑스', countryEn: 'France', emoji: '🇫🇷', description: '에펠탑, 루브르, 개선문', popular: true, lat: 48.8566, lng: 2.3522 },
    { id: 'uk-london', name: '런던', country: '영국', countryEn: 'UK', emoji: '🇬🇧', description: '빅벤, 타워브릿지', lat: 51.5074, lng: -0.1278 },
    { id: 'italy-rome', name: '로마', country: '이탈리아', countryEn: 'Italy', emoji: '🇮🇹', description: '콜로세움, 바티칸', lat: 41.9028, lng: 12.4964 },
    { id: 'spain-barcelona', name: '바르셀로나', country: '스페인', countryEn: 'Spain', emoji: '🇪🇸', description: '사그라다 파밀리아', lat: 41.3874, lng: 2.1686 },
    { id: 'swiss-zurich', name: '취리히', country: '스위스', countryEn: 'Switzerland', emoji: '🇨🇭', description: '알프스, 융프라우', lat: 47.3769, lng: 8.5417 },
    { id: 'czech-prague', name: '프라하', country: '체코', countryEn: 'Czech', emoji: '🇨🇿', description: '구시가지, 프라하성', lat: 50.0755, lng: 14.4378 },
    { id: 'croatia-dubrovnik', name: '두브로브니크', country: '크로아티아', countryEn: 'Croatia', emoji: '🇭🇷', description: '킹스랜딩, 성벽투어', lat: 42.6507, lng: 18.0944 },
    { id: 'turkey-istanbul', name: '이스탄불', country: '튀르키예', countryEn: 'Turkey', emoji: '🇹🇷', description: '블루모스크, 그랜드바자르', lat: 41.0082, lng: 28.9784 },
    { id: 'australia-sydney', name: '시드니', country: '호주', countryEn: 'Australia', emoji: '🇦🇺', description: '오페라하우스, 하버브릿지', popular: true, lat: -33.8688, lng: 151.2093 },
    { id: 'newzealand-auckland', name: '오클랜드', country: '뉴질랜드', countryEn: 'New Zealand', emoji: '🇳🇿', description: '스카이타워, 자연경관', lat: -36.8485, lng: 174.7633 },
    { id: 'mongolia-ub', name: '울란바토르', country: '몽골', countryEn: 'Mongolia', emoji: '🇲🇳', description: '초원, 게르 체험', lat: 47.8864, lng: 106.9057 },
];

// 해외 국가 목록 (그룹핑용)
export const getOverseasCountries = () => {
    const countryMap = new Map<string, { name: string; emoji: string; nameEn: string; count: number }>();
    OVERSEAS_DESTINATIONS.forEach(d => {
        if (!countryMap.has(d.country)) {
            countryMap.set(d.country, { name: d.country, emoji: d.emoji, nameEn: d.countryEn, count: 0 });
        }
        countryMap.get(d.country)!.count++;
    });
    return Array.from(countryMap.values());
};

/* TourAPI 직접 호출 코드는 걷어냈습니다.
   · 폐기된 KorService1 을 보고 있었고("해당 오픈API 서비스가 없거나 폐기됨"),
   · 키가 없어 늘 빈 배열을 돌려줬으며,
   · fetchTourSpots·searchTourSpots·TourSpot·CONTENT_TYPES·SYGIC_CATEGORIES 모두
     사용처가 0 이었습니다.
   이제 TourAPI 는 백엔드(TourApiService)가 부릅니다 — 프런트 번들에 키를 넣으면
   그대로 노출되고(REACT_APP_* 는 번들에 박힙니다) 하루 1,000건 제한을 캐시로
   막을 자리도 없습니다. 화면은 아래 getTravelPlaces 로 dokocrew-api 를 통해 받습니다. */

// 카테고리 한글 매핑
export const CATEGORY_LABELS: Record<string, { label: string; icon: string }> = {
    sightseeing: { label: '관광 명소', icon: '' },
    eating: { label: '맛집', icon: '' },
    shopping: { label: '쇼핑', icon: '' },
    sleeping: { label: '숙소', icon: '' },
    discovering: { label: '박물관/갤러리', icon: '' },
    going_out: { label: '나이트라이프', icon: '' },
    hiking: { label: '야외/하이킹', icon: '' },
    playing: { label: '가족/놀이', icon: '' },
    relaxing: { label: '휴식/스파', icon: '' },
};

// ─── dokocrew-api 캐시 경유 조회 ───

export interface TravelPlace {
    cacheId?: number;
    cityId: string;
    category: string;
    placeId: string;
    name: string;
    nameLocal?: string;
    description?: string;
    latitude?: number;
    longitude?: number;
    thumbnailUrl?: string;
    rating?: number;
    priceRange?: string;
    address?: string;
    phone?: string;
    openingHours?: string;
    admission?: string;
    tags?: string;
    source?: string;
}

/**
 * 여행지 관광 정보 조회 (dokocrew-api 캐시 경유)
 * - 백엔드가 Sygic/TourAPI를 캐싱하여 응답
 * - 프론트는 dokocrew-api만 호출
 */
export const getTravelPlaces = async (
    cityId: string,
    category?: string,
    limit: number = 20
): Promise<TravelPlace[]> => {
    try {
        const params: any = { cityId, limit };
        if (category) params.category = category;

        const response = await instance.get(getApiUrl('travelPlaces'), { params });
        return response?.data?.data || response?.data || [];
    } catch {
        return [];
    }
};
